import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import ApexChartComponent from "./Chart"; // Import the chart component
import Link from "antd/es/typography/Link";
import GraphModal from "./GraphModel";
import Papa from "papaparse";

const ElbowCurve = () => {
  // State to handle modal visibility
  const [showModal, setShowModal] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);

  // Function to open modal
  const handleShowModal = () => {
    setShowModal(true);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const fetchCSVData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch("/all_data_summary.csv"); // Replace with the actual CSV path
        const text = await response.text();

        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            const parsedData = results.data;

            if (!Array.isArray(parsedData) || parsedData.length === 0) {
              console.error("Parsed data is not valid or empty:", parsedData);
              setIsLoading(false);
              return;
            }

            setTableData(parsedData);

            // Dynamically create columns based on all keys in the first row of data
            const cols = Object.keys(parsedData[0]).map((key) => ({
              title: key,
              dataIndex: key,
              key,
            }));

            setColumns(cols);
            setIsLoading(false);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
            setIsLoading(false);
          },
        });
      } catch (error) {
        console.error("Error fetching CSV:", error);
        setIsLoading(false);
      }
    };

    fetchCSVData();
  }, []);

  return (
    <>
      <div className="page-wrapper">
        <h2 className="m-2">Step-2 Identify Optimal Cluster</h2>
        {/* <button className="btn btn-primary m-2" onClick={handleShowModal}>
        View Elbow Curve
      </button> */}
        <button className="btn btn-primary ms-4">
          <Link
            // className="dropdown-item"
            to="#"
            data-bs-toggle="modal"
            // data-bs-backdrop="static"
            aria-labelledby="delete"
            aria-hidden="true"
            // data-bs-target="#edit_leave"
            data-bs-target="#delete"
            style={{ color: "white" }}
          >
            View Elbow Curve
          </Link>
        </button>

        <div className="content container-fluid">
          {/* Modal to display the Elbow Curve */}
          {/* <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Elbow Curve</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ width: "100%", height: 350 }}>
              <ApexChartComponent />
            </div>
          </Modal.Body>
          <Modal.Footer style={{ marginTop: "40px" }}>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal> */}

          {/* Table to display other details */}
          <h2>Step-3 Run final iteration</h2>

          {isLoading ? (
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="table-responsive mt-4">
              <table className="table table-bordered">
                <tbody>
                  {/* Row for Cluster IDs */}
                  <tr>
                    <th>Cluster ID</th>
                    {tableData.map((row, index) => (
                      <td key={index}>{row.cluster}</td>
                    ))}
                  </tr>

                  {/* Row for No of Consumers */}
                  <tr>
                    <th>No of Consumers</th>
                    {tableData.map((row, index) => (
                      <td key={index}>{row["no of consumer"]}</td>
                    ))}
                  </tr>

                  {/* Row for Percentage */}
                  <tr>
                    <th>Percentage</th>
                    {tableData.map((row, index) => (
                      <td key={index}>{row.percentage}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      <GraphModal />
    </>
  );
};

export default ElbowCurve;
